export const messages = {
  en: require('./en.json'),
  de: require('./de.json'),
}
